import React, { useState, useEffect } from 'react';
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Checkbox } from "../components/ui/checkbox";
import { Label } from "../components/ui/label";

const SimplifiedESGForm = ({ initialData, onDataChange }) => {
  const [formData, setFormData] = useState(initialData);

  useEffect(() => {
    onDataChange(formData);
  }, [formData, onDataChange]);

  const handleChange = (name, value) => {
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="companyName">Company Name</Label>
        <Input
          id="companyName"
          value={formData.companyName}
          onChange={(e) => handleChange('companyName', e.target.value)}
          placeholder="Enter your company name"
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="industry">Industry</Label>
        <Select value={formData.industry} onValueChange={(value) => handleChange('industry', value)}>
          <SelectTrigger id="industry">
            <SelectValue placeholder="Select Industry" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="tech">Technology</SelectItem>
            <SelectItem value="manufacturing">Manufacturing</SelectItem>
            <SelectItem value="finance">Finance</SelectItem>
            <SelectItem value="healthcare">Healthcare</SelectItem>
            <SelectItem value="retail">Retail</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="employeeCount">Number of Employees</Label>
        <Input
          id="employeeCount"
          type="number"
          value={formData.employeeCount}
          onChange={(e) => handleChange('employeeCount', e.target.value)}
          placeholder="Enter number of employees"
          required
        />
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="trackCarbonEmissions"
          checked={formData.trackCarbonEmissions}
          onCheckedChange={(checked) => handleChange('trackCarbonEmissions', checked)}
        />
        <Label htmlFor="trackCarbonEmissions">Do you track carbon emissions?</Label>
      </div>

      <div className="space-y-2">
        <Label htmlFor="energyConsumption">Energy Consumption</Label>
        <Select value={formData.energyConsumption} onValueChange={(value) => handleChange('energyConsumption', value)}>
          <SelectTrigger id="energyConsumption">
            <SelectValue placeholder="Estimate Energy Consumption" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="low">Low</SelectItem>
            <SelectItem value="medium">Medium</SelectItem>
            <SelectItem value="high">High</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="womenPercentage">Percentage of Women in Workforce</Label>
        <Input
          id="womenPercentage"
          type="number"
          value={formData.womenPercentage}
          onChange={(e) => handleChange('womenPercentage', e.target.value)}
          placeholder="Enter percentage"
          min="0"
          max="100"
          required
        />
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="hasBoard"
          checked={formData.hasBoard}
          onCheckedChange={(checked) => handleChange('hasBoard', checked)}
        />
        <Label htmlFor="hasBoard">Do you have a board of directors?</Label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="hasEthicsCode"
          checked={formData.hasEthicsCode}
          onCheckedChange={(checked) => handleChange('hasEthicsCode', checked)}
        />
        <Label htmlFor="hasEthicsCode">Do you have a code of ethics?</Label>
      </div>
    </div>
  );
};

export default SimplifiedESGForm;